export default "__VITE_ASSET__9e9b5490__"